import { managerGridHeight } from '~/utils';

const styles = {
  container: {
    display: 'flex',
    backgroundColor: '#F9F9F9',
    height: managerGridHeight,
    padding: 10,
  },
  icon: {
    marginRight: 10,
  },
  button: {
    color: '#FFF',
    margin: 5,
  },
  tabContainer: {
    borderRadius: 5,
    borderTopLeftRadius: 0,
    backgroundColor: 'white',
    padding: 10,
    maxWidth: 'calc(100vw - 180px)',
  },
  field: {
    border: '1px solid #CDCDCD',
    borderRadius: 5,
    height: 40,
    maxWidth: 290,
  },
  fieldError: {
    border: '1px solid red !important',
    borderRadius: 5,
    height: 40,
  },
  classGroupName: {
    flex: 1,
    minWidth: 290,
    marginLeft: 10,
    marginRight: 10,
  },
  formLabel: {
    color: '#647886',
    fontSize: 12,
    fontFamily: 'Roboto',
    marginBottom: 5,
  },
  errorMessage: {
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: 12,
    textAlign: 'center',
    color: '#EC3337',
  },
  table: {
    height: 'calc(100vh - 52px - 52px - 230px)',
  },
  fab: {
    background: 'none',
    boxShadow: 'none',
    color: '#F2AA00',
    '&:hover': {
      backgroundColor: '#F1F1F1',
    },
  },
  activeRow: {
    backgroundColor: '#b7ffb3',
  },
  inactiveRow: {
    backgroundColor: '#FFE2E2',
  },
  formControl: {
    zIndex: 11,
    marginLeft: 10,
  },
  searchButton: {
    color: '#FFF',
    marginLeft: 10,
  },
};

export default styles;
